import { render, staticRenderFns } from "./PageLogs.vue?vue&type=template&id=300056b3&scoped=true"
import script from "./PageLogs.vue?vue&type=script&lang=js"
export * from "./PageLogs.vue?vue&type=script&lang=js"
import style0 from "./PageLogs.vue?vue&type=style&index=0&id=300056b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300056b3",
  null
  
)

export default component.exports